import BrandsPage from 'src/dispensary/core-menu/brands';
import { CoreMenuLayout } from 'components/layouts/core-menu-layout';
import { withLayout } from 'src/components/layouts/with-layout';

export default withLayout(BrandsPage, CoreMenuLayout);
